import { render, staticRenderFns } from "./activeRank.vue?vue&type=template&id=be6e47ae&scoped=true&"
import script from "./activeRank.vue?vue&type=script&lang=js&"
export * from "./activeRank.vue?vue&type=script&lang=js&"
import style0 from "./activeRank.vue?vue&type=style&index=0&id=be6e47ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be6e47ae",
  null
  
)

export default component.exports